import { create } from 'zustand';

/**
 * Drives the seamless re-auth modal (TRU-301).
 *
 * When the fetch wrapper's silent refresh-and-retry finally fails (the refresh
 * token itself is expired/revoked), `lib/api.ts` opens this modal instead of
 * force-logging-out. The user re-authenticates in place — their stale tokens
 * and `user`/`workspace` are intentionally left in storage so the route, route
 * guards, and the email/workspace pre-fill all survive (see `lib/api.ts`).
 *
 * Ephemeral by design — NOT persisted. The burst of concurrent 401s that
 * triggers expiry all call `open()`, so it must be idempotent (a plain
 * `isOpen: true` set is).
 */
export interface ReauthState {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

export const useReauthStore = create<ReauthState>((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
}));
